import PlanPickerModal from "@/components/settings/plan/planPickerModal";
import { useWorkspaceContext } from "@/contexts/workspaceContext";
import ModalProvider from "@repo/components/src/globalProviders/modal";
import { useCallback } from "react";

/**
 * Opens the plan picker over the current screen. `returnPath` is the in-app
 * path (e.g. `/app/12/campaign/ai?sessionId=9`) the checkout lands back on,
 * where `useCheckoutReturn` picks the payment up.
 */
export const usePlanPicker = (): ((returnPath: string) => void) => {
  const { billingCountry, billingCurrencyCode } = useWorkspaceContext();
  const billingCountryId = billingCountry?.id ?? null;
  return useCallback(
    (returnPath: string) => {
      ModalProvider.show({
        children: (
          <PlanPickerModal
            billingCountryId={billingCountryId}
            billingCurrencyCode={billingCurrencyCode}
            returnPath={returnPath}
          />
        ),
        size: "lg",
        contentProps: { className: "rounded-2xl w-full max-w-[1040px]" },
      });
    },
    [billingCountryId, billingCurrencyCode],
  );
};
